var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { DataStore } from '../services/datastore.service';
let AppUpdateEmail = class AppUpdateEmail extends LitElement {
    constructor() {
        super();
        this._id = undefined;
        this._randomized = undefined;
        this.email = undefined;
        this.error = undefined;
        this.datastore = DataStore.getInstance();
        this.datastore.clearData();
    }
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        this._id = this.location.params.id;
        this._randomized = this.location.params.randomized;
        this.datastore.changeEmail(this._id, this._randomized)
            .then(response => {
            this.email = response.email;
            this.requestUpdate();
        })
            .catch((error) => {
            this.error = JSON.parse(error.body).errortext;
        });
    }
    login() {
        this.datastore.redirect('/login');
    }
    render() {
        return html `
      <div class="card">
        <div class="card-content">
          <div class="mt-2 mb-2">
            ${this.email ? html `
              Congratulations, your email has been changed to <span class="has-text-weight-bold">${this.email}</span><br>
              <br>
              You can now login with your existing password and the new email.<br>
              <br>
              <div class="control mt-4">
                <button class="button is-primary" @click="${this.login}">
                  <span class="icon">
                    <i class="fas fa-unlock"></i>
                  </span>
                  <span>Login</span>
                </button>
              </div>
            ` : ''}
            ${this.error ? html `
              Update email failed with the following error<br>
              <br>
              <span class="has-text-weight-bold">${this.error}</span>
            ` : ''}
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    property()
], AppUpdateEmail.prototype, "location", void 0);
AppUpdateEmail = __decorate([
    customElement('app-update-email')
], AppUpdateEmail);
export { AppUpdateEmail };
//# sourceMappingURL=anon_update_email.js.map